/* eslint-disable import/prefer-default-export */
const isEmptyString = (str) => (
  str && str.trim().length > 0
);

export {
  isEmptyString,
}
/* eslint-enable import/prefer-default-export */
